interface GlobalPopupStateModel {
  component: any
  props: any
  showContent: boolean
}

const defaultProps = {
  transition: { name: 'slide-up' },
  selfClick: true,
};

const globalPopupState = reactive<GlobalPopupStateModel>({
  component: null,
  props: defaultProps,
  showContent: false,
});
export function usePopups() {
  const openPopup = (name: string, props = {}) => {
    globalPopupState.component = defineAsyncComponent(() => import(`../components/popup/components/${name}.vue`));
    globalPopupState.props = { ...defaultProps, ...props };
  };

  const toggleComponent = (state?: boolean) => {
    globalPopupState.showContent = typeof state === 'boolean' ? state : !globalPopupState.showContent;
  };
  const closePopup = () => {
    globalPopupState.component = null;
    globalPopupState.props = defaultProps;
  };

  return { globalPopupState, closePopup, openPopup, toggleComponent };
}
